import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import { BiPlus } from "react-icons/bi";
import PatientMedicineServiceModal from "./PatientMedicineServiceModal";
import { Button, Input } from "../Form";
import { toast } from "react-hot-toast";

function AddItemModal({ closeModal, isOpen, onAddItem }) {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const calculateTotal = () => {
    return (selectedItem?.price || 0) * quantity;
  };

  const summery = [
    {
      title: "Service Name",
      value: selectedItem?.title || "Select Item",
      color: false,
    },
    {
      title: "Item Price",
      value: `${selectedItem?.price || 0} Tsh`,
      color: false,
    },
    {
      title: "Quantity",
      value: quantity,
      color: false,
    },
    {
      title: "Total",
      value: `${calculateTotal()} Tsh`,
      color: true,
    },
  ];

  const handleAdd = () => {
    if (!selectedItem) return toast.error("Please select a service or medicine");
    if (quantity <= 0) return toast.error("Quantity must be at least 1");

    onAddItem({
      newItem: {
        ...selectedItem,
        id: selectedItem.id, // Ensure ID is passed
        name: selectedItem.title, // Map title back to name for table
      },
      quantity: Number(quantity)
    });
    setSelectedItem(null);
    setQuantity(1);
    closeModal();
  };

  return (
    <>
      {open && (
        <PatientMedicineServiceModal
          closeModal={() => setOpen(!open)}
          isOpen={open}
          patient={false}
          onSelect={(item) => setSelectedItem(item)}
        />
      )}
      <Modal
        closeModal={closeModal}
        isOpen={isOpen}
        title='Add Item'
        width={"max-w-xl"}
      >
        <div className='flex-colo gap-6'>
          {/* title */}
          <div className='flex w-full flex-col gap-4'>
            <p className='text-sm text-black'>Service / Medicine</p>
            <button
              onClick={() => setOpen(!open)}
              className='flex-rows w-full gap-2 rounded-lg border border-dashed border-subMain py-4 text-sm text-subMain'
            >
              {selectedItem ? selectedItem.title : <><BiPlus /> Add Item</>}
            </button>
          </div>
          {/* quantity */}
          <Input
            label='Quantity'
            color={true}
            type={"number"}
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
          {/* summery */}
          <div className='flex w-full flex-col gap-4'>
            <p className='text-sm text-black'>Summary</p>
            <div className='flex flex-col gap-4'>
              {summery.map((item, index) => (
                <div
                  key={index}
                  className='flex flex-row items-center justify-between'
                >
                  <p className='text-xs text-textGray'>{item.title}</p>
                  <p
                    className={
                      item.color
                        ? "rounded-full bg-subMain bg-opacity-10 px-4 py-1 text-xs font-semibold text-subMain"
                        : "text-sm font-medium text-textGray"
                    }
                  >
                    {item.value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* button */}
          <Button onClick={handleAdd} label='Add' Icon={BiPlus} />
        </div>
      </Modal>
    </>
  );
}

export default AddItemModal;
